import { type SchemaOrgFragmentFragment } from '@packages/gql/generated/shopping/graphql';

export type GetRatingTagsType = {
  ratingForSchema: SchemaOrgFragmentFragment['ratingForSchema'];
};

export const getRatingTags = ({ ratingForSchema }: GetRatingTagsType) => {
  if (!ratingForSchema || !ratingForSchema?.product) {
    return {};
  }

  const {
    product: {
      tags: { pro, contra },
    },
  } = ratingForSchema;

  const pros = pro?.length
    ? pro.map(({ tag }, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: tag.name,
      }))
    : null;

  const contras = contra?.length
    ? contra.map(({ tag }, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: tag.name,
      }))
    : null;

  return {
    ...(pros && {
      positiveNotes: {
        '@type': 'ItemList',
        itemListElement: pros,
      },
    }),
    ...(contras && {
      negativeNotes: {
        '@type': 'ItemList',
        itemListElement: contras,
      },
    }),
  };
};
